import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { identifyUser, parseURLParams, Notification } from '@offerzen/pinata'

import githubLogo from '../../../assets/social-signup-github.png'
import googleLogo from '../../../assets/social-signup-google.png'
import linkedinLogo from '../../../assets/social-signup-linkedin.png'

import { createCandidateFailed as reduxCreateCandidateFailed } from '../../redux/modules/candidate'
import SocialSignupButton from '../../components/SocialSignupButton'

import styles from './styles'

class SocialSignup extends Component {
  windowObjectReference = null

  previousUrl = null

  componentWillUnmount() {
    window.removeEventListener('message', this.receiveMessage)
  }

  constructSocialSignupUrl(provider, urlParameters) {
    let urlPath = `/oauth/initialize?provider=${provider}&social_action=create`

    Object.keys(urlParameters).map((key, index) => {
      const urlParamValue = urlParameters[key]
      if (urlParamValue) {
        urlPath = `${urlPath}&${key}=${urlParamValue}`
      }
    })

    return urlPath
  }

  socialSignupOnClick(event, provider) {
    event.preventDefault()

    const urlParams = parseURLParams(this.props.location.search)
    const { report_source, rx_job, rx_viewer, irclickid } = urlParams
    const referrer = encodeURIComponent(this.props.location.href || window.location.href)
    const urlMarketingParameters = {
      // analytics property to indicate report source
      report_source,
      // rx_job is a job id for Recruitics (marketing partner) that is tracked by performance marketing
      rx_job,
      // rx_viewer is a viewer id for Recruitics (marketing partner) that is tracked by performance marketing
      rx_viewer,
      // irclickid is a click id for Impact (marketing partner) that is tracked by performance marketing
      irclickid,
      // page url the user landed on
      referrer,
    }

    const constructedUrlPath = this.constructSocialSignupUrl(provider, urlMarketingParameters)

    this.openSignInWindow(constructedUrlPath, provider)
  }

  openSignInWindow(url, name) {
    window.removeEventListener('message', this.receiveMessage)
    const popUpHeight = 700
    const popUpWidth = 600
    const y = (window.top.outerHeight - popUpHeight) / 2 + window.top.screenY
    const x = (window.top.outerWidth - popUpWidth) / 2 + window.top.screenX

    const strWindowFeatures = `toolbar=no, menubar=no, width=${popUpWidth}, height=${popUpHeight}, top=${y}, left=${x}`

    if (this.windowObjectReference === null || this.windowObjectReference.closed) {
      this.windowObjectReference = window.open(url, name, strWindowFeatures)
    } else if (this.previousUrl !== url) {
      this.windowObjectReference = window.open(url, name, strWindowFeatures)
      this.windowObjectReference.focus()
    } else {
      this.windowObjectReference.focus()
    }

    window.addEventListener('message', event => this.receiveMessage(event), false)
    this.previousUrl = url
  }

  receiveMessage(event) {
    const { auth_state, attempted_provider, user_id } = event.data

    if (auth_state === 'account_exists' || auth_state === 'different_provider') {
      this.props.createCandidateFailed(
        <span>
          An account already exists using this email. <a href="/users/sign_in">Log in to continue.</a>
        </span>,
        attempted_provider,
      )
    }

    if (auth_state === 'failure') {
      this.props.createCandidateFailed(null, attempted_provider, auth_state)
    }

    if (auth_state === 'success') {
      identifyUser(user_id)
      this.props.refetchCurrentUser()
    }
  }

  renderErrorMessages() {
    if (
      this.props.candidate &&
      this.props.candidate.error &&
      (this.props.candidate.provider !== 'email' || this.props.candidate.authState === 'failure')
    ) {
      return (
        <div className={styles.errorNotification}>
          <Notification theme="error">
            <Choose>
              <When condition={this.props.candidate.error === 'Email is already taken'}>
                An account already exists using this email. <a href="/users/sign_in">Log in to continue.</a>
              </When>

              <Otherwise>{this.props.candidate.error}</Otherwise>
            </Choose>
          </Notification>
        </div>
      )
    }
  }

  render() {
    const socialButtons = [
      {
        name: 'Google',
        logo: googleLogo,
        provider: 'google',
      },
      {
        name: 'LinkedIn',
        logo: linkedinLogo,
        provider: 'linkedin',
      },
      {
        name: 'GitHub',
        logo: githubLogo,
        provider: 'github',
      },
    ]

    return (
      <div>
        {this.renderErrorMessages()}
        <span className={styles.heading}>Sign up with:</span>
        <div className={styles.buttonsContainer}>
          {socialButtons.map(social => (
            <SocialSignupButton
              key={social.provider}
              name={social.name}
              logo={social.logo}
              onClick={e => this.socialSignupOnClick(e, social.provider)}
              provider={social.provider}
            />
          ))}
        </div>
        <p className={styles.disclaimer}>
          By signing up you consent to receive communications that help with your job search. You understand and agree to OfferZen's{' '}
          <a href="/terms/candidate" target="_blank" rel="noopener noreferrer">
            T&amp;Cs
          </a>
          ,{' '}
          <a href="/privacy" target="_blank" rel="noopener noreferrer">
            privacy policy
          </a>{' '}
          and{' '}
          <a href="/cookie-declaration/" target="_blank" rel="noopener noreferrer">
            use of cookies
          </a>
          .
        </p>
        <div className={styles.seperator}>
          <span className={styles.seperatorText}>OR</span>
        </div>
        <span className={styles.heading}>Continue with email:</span>
      </div>
    )
  }
}

SocialSignup.propTypes = {
  refetchCurrentUser: PropTypes.func,
}

const mapDispatchToProps = dispatch => ({
  createCandidateFailed: (error, provider, authState) => dispatch(reduxCreateCandidateFailed(error, provider, authState)),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
})

export default connect(null, mapDispatchToProps, mergeProps)(SocialSignup)
